var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31348 0.135742H1.08301V6.54102C1.08301 8.64648 2.55273 10.1641 5 10.1641C7.44727 10.1641 8.91699 8.64648 8.91699 6.54102V0.135742H7.68652V6.45898C7.68652 7.94922 6.70898 9.0293 5 9.0293C3.29102 9.0293 2.31348 7.94922 2.31348 6.45898V0.135742Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12H0.5V11H9.5V12Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineButton);
export default __webpack_public_path__ + "static/media/underlineButton.9a6827027fbb75d5540aec044f895f17.svg";
export { ForwardRef as ReactComponent };